import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./translations";

/**
 * Admin-panel i18n bootstrap.
 *
 * Persists the chosen language under localStorage key `admin_language`
 * so reloads and tab-switches stay consistent. Defaults to English.
 *
 * Usage in components:
 *   const { t, i18n } = useTranslation();
 *   <span>{t("sidebar.dashboard")}</span>
 *   <button onClick={() => i18n.changeLanguage("hi")}>हिंदी</button>
 */

const LANG_STORAGE_KEY = "admin_language";
const savedLang = typeof window !== "undefined" ? window.localStorage.getItem(LANG_STORAGE_KEY) : null;

void i18n.use(initReactI18next).init({
  resources,
  lng: savedLang ?? "en",
  fallbackLng: "en",
  interpolation: {
    // React already escapes, so disable i18next's default escaping.
    escapeValue: false,
  },
  returnNull: false,
});

// Persist language changes without wiring a separate hook in every consumer.
i18n.on("languageChanged", (lng) => {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lng);
  } catch {
    // localStorage may be unavailable in private mode; safe to ignore.
  }
});

export default i18n;
